import colorNames from './color-names'

const tokens = {
  spacing: {
    base: '8',
    baseN: 8,
    xxSmall: '2px',
    xSmall: '4px',
    small: '8px',
    medium: '16px',
    large: '24px',
    xLarge: '32px',
    xxLarge: '40px',
    xxxLarge: '48px'
  },
  grid: {
    gutter: '16px',
    gutterN: 16
  },
  fontWeight: {
    normal: 400,
    bold: 500
  },
  fontSize: {
    xlarge: '28px',
    large: '22px',
    medium: '18px',
    standard: '15px',
    small: '14px',
    xsmall: '13px'
  },
  fontStyle: {
    normal: 'normal',
    italic: 'italic'
  },
  letterSpacing: {
    small: '0.02em',
    standard: '0.03em',
    large: '0.04em'
  },
  lineHeight: {
    standard: '1.3em',
    title: '1.2em'
  },
  color: {
    text: {
      default: colorNames.mineShaft,
      light: colorNames.boulder,
      extralight: colorNames.silver,
      danger: colorNames.sunsetOrange,
      defaultNegative: colorNames.pureWhite
    },
    link: {
      default: {
        link: colorNames.mineShaft,
        hover: colorNames.blueChill
      },
      highlight: {
        link: colorNames.java,
        hover: colorNames.blueChill
      },
      extralight: {
        link: colorNames.boulder,
        hover: colorNames.blueChill
      },
      danger: {
        link: colorNames.sunsetOrange,
        hover: colorNames.sunsetOrange
      },
      defaultNegative: {
        link: colorNames.pureWhite,
        hover: colorNames.java
      },
      extralightNegative: {
        link: colorNames.silver01,
        hover: colorNames.silver01
      },
      disabled: {
        link: colorNames.silverChalice03,
        hover: colorNames.silverChalice03
      }
    }
  },
  borderWidth: {
    default: '1px'
  },
  borderRadius: {
    xsmall: '3px',
    small: '4px',
    medium: '6px',
    max: '100%'
  },
  shadows: {
    default: '0 3px 6px rgba(37, 37, 37, 0.15)',
    medium: '0 3px 6px rgba(219, 219, 219, 1)'
  },
  opacity: {
    default: 1,
    hidden: 0,
    overlay: 0.9
  },
  transition: {
    color: 'color 0.25s ease;'
  }
}

export default tokens

export const input = {
  color: {
    background: {
      default: colorNames.pureWhite,
      disabled: colorNames.mercury01
    },
    border: {
      default: colorNames.geyser,
      danger: colorNames.sunsetOrange,
      disabled: colorNames.geyser,
      hover: colorNames.bombay
    },
    text: {
      default: colorNames.tundora,
      disabled: colorNames.tundora
    }
  },
  borderRadius: tokens.borderRadius.small,
  borderWidth: tokens.borderWidth.default,
  height: '36px',
  minHeight: '36px'
}

export const toggleButton = {
  color: {
    text: {
      default: colorNames.silverChalice01,
      hover: colorNames.mineShaft,
      selected: colorNames.mineShaft,
      disabled: colorNames.silverChalice01
    },
    background: {
      default: colorNames.pureWhite
    },
    border: {
      default: colorNames.geyser,
      hover: colorNames.bombay
    }
  },
  opacity: {
    default: 1,
    disabled: 0.4
  },
  padding: `0 ${tokens.spacing.medium}`,
  borderWidth: tokens.borderWidth.default,
  borderRadius: tokens.borderRadius.small,
  height: '36px',
  minHeight: '36px'
}
